import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { Paper, Stack, Typography, IconButton, Box, Avatar, Button, styled, Skeleton } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import heic2any from "heic2any";
import { RootStateType } from '../../redux/features/rootSlice';
import { useArcAuth } from "@arcauth/react-sdk";
import EditIcon from "../../shared/icon/edit-icon";
import GlobeIcon from "../../shared/icon/globe-icon";
import ClockIcon from "../../shared/icon/clock-icon";
import NameUpdate from "./name_update";
import EmailUpdate from "./email_update";
import { getInitials } from "../../shared/util/encrypt.decrypt";
import PhoneUpdate from "./phone_update";
import PasswordUpdate from "./password_update";
import LanguageUpdate from "./language_update";
import TimeZoneUpdate from "./time_zone_update";
import ImageCropper from "../../shared/util/imageCropper";
import { Navigate } from "react-router-dom";
import { getPresignedUrl, uploadImageRequest } from "../../redux/features/s3upload.slice";
import { toastError } from "../../shared/util/toast.message";
import { getUserInfo } from "../../redux/features/user.slice";
import { anotherUpdateDate, getCalendarTime } from "../../shared/util/dateformatter";
import ChromeIcon from "../../shared/icon/chrome-icon";
import SafariIcon from "../../shared/icon/safari-icon";
import CameraIcon from "../../shared/icon/camera-icon";
import useWebSocket from "../../hooks/useWebSocket";
import { webSocketMessage } from "../../config/app";
import DevicesLogedinList from "../devices/list";
import SetPassword from "./set_password";

interface loadingSkel {
  loading?: boolean;
}

const MyAccount = (props: loadingSkel) => {
  const { loading = false } = props;
  const { isAuthenticated, login } = useArcAuth();
  const { updateUserAndNotifyParent } = useWebSocket();
  let user = useSelector(
    (state: RootStateType) => state.userStateReducer.user
  );
  let { loginDevice } = useSelector(
    (state: RootStateType) => state.authStateReducer
  );
  const headerText = getInitials(user?.firstname);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedField, setSelectedField] = useState<any>();
  const [openName, setOpenName] = useState(false);
  const [openEmail, setOpenEmail] = useState(false);
  const [openPhone, setOpenPhone] = useState(false);
  const [openPass, setPassword] = useState(false);
  const [openPassword, setAddPassword] = useState(false);
  const [openlanguage, setLanguage] = useState(false);
  const [openTimeZone, setTimeZone] = useState(false);
  const [prevSelectedFile, setPrevSelectedFile] = useState<File | null>(null);
  const [cropFlag, setCropFlag] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [AvatarImage, setAvatarImage] = useState(false);
  const [fileType, setFileType] = useState<any>();
  const lastPasswordUpdateDate = getCalendarTime(user?.passwordlastupdated)
  const editname = (user: any) => {
    OpenDialog(user);
    setOpenName(true);
  }

  const editemail = (email: any) => {
    OpenDialog(email);
    setOpenEmail(true);
  }
  const editphone = (user: any) => {
    OpenDialog(user);
    setOpenPhone(true);
  }
  const changePass = () => {
    setPassword(true);
  }
  const setChangePassword = () => {
    setAddPassword(true);
  }
  const editlanguage = (user: any) => {
    OpenDialog(user);
    setLanguage(true);
  }
  const edittimezone = (user: any) => {
    OpenDialog(user);
    setTimeZone(true);
  }
  const OpenDialog = (user: any) => {
    setSelectedField({
      id: user?.id,
      firstname: user?.firstname,
      lastname: user?.lastname,
      phone: user?.phone,
      email: user?.email,
      newpassword: user?.newpassword,
      oldpassword: user?.oldpassword,
      preferredlanguages: user?.preferredlanguages,
      timezone: user?.timezone,
    });
    setOpen(true);
  };
  const DialogClose = () => {
    setTimeZone(false);
    setLanguage(false);
    setPassword(false);
    setOpenPhone(false);
    setOpenName(false);
    setOpenEmail(false);
    setAvatarImage(false);
    setPassword(false);
    setAddPassword(false);
  };
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleUploadImage = () => {

    // Trigger the input element when the button is clicked
    fileInputRef.current!.click();
  };
  const handleUploadImageRequest = (img: File) => {

    let imagInfo = {
      id: user?.id,
      selectedFile: img,
      path: `avatar`,
      successCallback: () => {
        updateUserAndNotifyParent(webSocketMessage.imageResponse);
        dispatch(getUserInfo());
        setCropFlag(false);
        // setSelectedFile(null);
        DialogClose();

      },
    }

    dispatch(getPresignedUrl(
      {
        userId: user?.id,
        successCallback: (presignedUrl: string) => {
          dispatch(uploadImageRequest({ ...imagInfo, presignedUrl }));
        },
      }
    ));
  };

  // const handleFileChanges = (event: ChangeEvent<HTMLInputElement>) => {
  //   const files: any = event.target.files;
  //   if (files && files.length > 0) {
  //     setAvatarImage(true);
  //     setPrevSelectedFile(selectedFile);
  //     setCropFlag(false);
  //     // console.log("files", files[0].type);
  //     setFileType(files[0].type);
  //     if (files[0].type === "image/png" || files[0].type === "image/jpeg") {
  //       setSelectedFile(files[0]);
  //       setCropFlag(true)
  //     }
  //     else {
  //       toastError("Select only image/png or image/jpeg file");
  //     }
  //   }
  // };

const handleFileChanges = async (event: ChangeEvent<HTMLInputElement>) => {
  const files = event.target.files;
  console.log("files", files)
  if (!files || files.length === 0) return;

  const originalFile = files[0]; // Get the selected file
  let convertedFile = originalFile; // Default to the original file

  // Supported file types and extensions
  const supportedTypes = ["image/jpg", "image/jpeg", "image/png", "image/heic"];
  const supportedExtensions = [".jpg", ".jpeg", ".png", ".heic"];

  // Check if the file is supported by type or extension
  const isSupportedType = supportedTypes.includes(originalFile.type);
  const isSupportedExtension = supportedExtensions.some((ext) =>
    originalFile.name.toLowerCase().endsWith(ext)
  );

  if (isSupportedType || isSupportedExtension) {
    // Handle HEIC conversion
    if (
      originalFile.type === "image/heic" ||
      originalFile.name.toLowerCase().endsWith(".heic")
    ) {
      try {
        convertedFile = await convertHeicToJpeg(originalFile); // Convert HEIC to JPEG
      } catch (error) {
        console.error("Error converting HEIC file:", error);
        toastError("Failed to convert HEIC file. Please try again.");
        return;
      }
    }

    // Process the (converted or original) file
    const blobUrl = URL.createObjectURL(convertedFile); // Create a blob URL (for preview if needed)
    console.log("File ready for upload or preview:", blobUrl);
        setSelectedFile(convertedFile);
        setCropFlag(true)
  } else {
    // Unsupported file type
    toastError("Please select a file in JPG, JPEG, PNG, or HEIC format.");
  }
};

// HEIC to JPEG Conversion Function
const convertHeicToJpeg = async (heicFile: File) => {
  try {
    const blobOrBlobs = await heic2any({
      blob: heicFile,
      toType: "image/jpeg",
      quality: 0.8,
    });

    // Check if the result is a single Blob or an array of Blobs
    const blob = Array.isArray(blobOrBlobs) ? blobOrBlobs[0] : blobOrBlobs;

    // Create a new File object from the Blob
    return new File(
      [blob],
      heicFile.name.replace(/\.[^/.]+$/, "") + ".jpeg", // Replace extension with .jpeg
      {
        type: "image/jpeg",
        lastModified: new Date().getTime(),
      }
    );
  } catch (error) {
    console.error("Error converting HEIC to JPEG:", error);
    throw error;
  }
};


  useEffect(() => {
    if (!isAuthenticated) {
      login();
    }
  }, [isAuthenticated, Navigate]);


  return (
    <Box>
      <Stack textAlign={'center'} gap={1} alignItems={"center"} mb={3}>
        <Typography variant="h1" color="initial" fontSize={{ xs: '1.5rem', md: '2.5rem' }}>
          My account
        </Typography>
        <Typography variant="body2" color="initial">
          Manage your account preferences and details in one convenient location
        </Typography>
      </Stack>
      <Stack gap={2} sx={{ maxWidth: 800, mx: 'auto' }}>
        {loading ? (
          <Skeleton sx={{ background: '#fff' }} variant="rectangular" width="100%" height={230} />
        ) : (
          <Paper elevation={0} sx={{ p: 3 }}>
            <Typography variant="h6" color="initial">Basic info</Typography>
            <Typography variant="body2" color="initial" mb={3}>Access the basic info settings to customize your preferences and manage essential details effortlessly</Typography>
            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{ borderBottom: '1px solid #eee', py: 1 }}>
              <Typography flex={1} variant="body2" color="secondary.light">Profile picture</Typography>
              <Typography flex={2} variant="body2" color="secondary.light">A profile picture helps other recognise</Typography>
              <Avatar sx={{
                position: 'relative', cursor: 'pointer', '&:hover': {
                  '.camera-icon': {
                    opacity: 1,
                    transform: 'translateY(0)',
                  }
                }, '::after': { content: "''", width: '100%', height: '100%', background: 'rgba(0,0,0,.3)', position: 'absolute' }
              }} onClick={handleUploadImage}>
                {user?.imageurl ?
                  (
                    <img crossOrigin="anonymous" src={`${user?.imageurl}`} alt="" width={50} height={50} style={{width:'100%', height: '100%', display:'block', objectFit: 'cover'}} />

                  )
                  : (headerText)}
                <VisuallyHiddenInput
                  type="file"
                  accept="image/png, image/jpeg, image/heic"
                  ref={fileInputRef}
                  onChange={handleFileChanges}
                />
                <Box className="camera-icon" sx={{
                  position: 'absolute',
                  bottom: 0,
                  zIndex: 1,
                  opacity: 0,
                  transform: 'translateY(100%)',
                  transition: 'opacity 0.3s ease, transform 0.3s ease',
                }}>
                  <CameraIcon />
                </Box>
              </Avatar>
            </Stack>
            <Box>

              {selectedFile && cropFlag && (
                <ImageCropper
                  userid={user?.id}
                  open={AvatarImage}
                  onClose={DialogClose}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                  setCropFlag={setCropFlag}
                  prevSelectedFile={prevSelectedFile}
                  handleUploadImageRequest={handleUploadImageRequest}

                />

              )}
            </Box>
            {/* <Box display={'grid'} alignItems={'center'} minHeight={57} gridTemplateColumns={'200px 1fr 42px'} sx={{ borderBottom: '1px solid #eee', py: 1 }}>
            <Typography variant="body2" color="secondary.light">Arc account</Typography>
            <Typography variant="body2" color="initial">ARC23125454</Typography>
            <IconButton aria-label="edit" onClick={editacc}>
              <EditIcon />
            </IconButton>
          </Box> */}
            <Stack direction={'row'} justifyContent={'space-between'} sx={{ borderBottom: '1px solid #eee', py: 1 }}>
              <Typography flex={1} variant="body2" color="secondary.light">Name</Typography>
              <Typography flex={2} variant="body2" color="initial">{user?.firstname}{" "}{user?.lastname}</Typography>
              <IconButton aria-label="edit" onClick={() => editname(user ?? "")}>
                <EditIcon />
              </IconButton>
            </Stack>
          </Paper>
        )}
        {
          loading ? (
            <Skeleton sx={{ background: '#fff' }} variant="rectangular" width="100%" height={230} />
          ) : (
            <Paper elevation={0} sx={{ p: 3 }}>
              <Typography variant="h6" color="initial">Contact info</Typography>
              <Typography variant="body2" color="initial" mb={3}>Access your contact information through account settings</Typography>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ borderBottom: '1px solid #eee', py: 1 }}>
                <Typography flex={1} variant="body2" color="secondary.light">Email</Typography>
                <Typography flex={2} variant="body2" color="initial">{user?.email}</Typography>
                {/* <IconButton aria-label="edit" onClick={() => editemail(user ?? "")}>
                  <EditIcon />
                </IconButton> */}
              </Stack>
              <Stack direction={'row'} justifyContent={'space-between'} sx={{ borderBottom: '1px solid #eee', py: 1 }}>
                <Typography flex={1} variant="body2" color="secondary.light">Phone number</Typography>
                <Typography flex={2} variant="body2" color="initial">{user?.phone}</Typography>
                <IconButton aria-label="edit" onClick={() => editphone(user ?? "")}>
                  <EditIcon />
                </IconButton>
              </Stack>
            </Paper>
          )
        }

        {/* <Stack direction={"row"} gap={2}>
        <Paper elevation={0} sx={{ p: 3, flex: 1 }}>
            <Typography variant="h6" color="initial">
              Password
            </Typography>
            <Typography variant="body2" color="initial" mb={3}>
              Customize password settings for enhanced security
            </Typography>
              {user?.passwordchangerequired ?
                <>
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    sx={{ borderBottom: "1px solid #eee", py: 1 }}
                  >
                    <Stack>
                      <Typography variant="body2" color="secondary.light">
                        ••••••••
                      </Typography>
                    </Stack>
                  </Stack>
                  <Box py={1}>
                    <Button variant="text" color="primary" onClick={setChangePassword} sx={{ ':hover': { background: 'transparent' }, p: 0, minWidth: 0 }}>
                      Set Password
                    </Button>
                  </Box>
                </>
                :
                <>
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    sx={{ borderBottom: "1px solid #eee", py: 1 }}
                  >
                    <Stack>
                      <Typography variant="body2" color="secondary.light">
                        ••••••••
                      </Typography>
                      <Typography variant="body2" color="initial">
                        <small>Last changed {lastPasswordUpdateDate}</small>
                      </Typography>
                    </Stack>
                  </Stack>
                  <Box py={1}>
                    <Button variant="text" color="primary" onClick={changePass} sx={{ ':hover': { background: 'transparent' }, p: 0, minWidth: 0 }}>
                      Change Password
                    </Button>
                  </Box>
                </>
              }
          </Paper>
          <Paper elevation={0} sx={{ p: 3, flex: 1 }}>
            <Typography variant="h6" color="initial">
              General Settings
            </Typography>
            <Typography variant="body2" color="initial" mb={3}>
              Customize settings for control
            </Typography>

            <Box
              display={"grid"}
              alignItems={"center"}
              gridTemplateColumns={"30px 1fr 42px"}
              sx={{ borderBottom: "1px solid #eee", py: 1 }}
            >
              <GlobeIcon />
              <Stack>
                <Typography variant="body2" color="secondary.light">
                  Language
                </Typography>
                <Typography variant="body2" color="initial">
                  {user?.preferredlanguages}
                </Typography>
              </Stack>
              <IconButton aria-label="edit" onClick={() => editlanguage(user ?? "")}>
                <EditIcon />
              </IconButton>
            </Box>
            <Box
              display={"grid"}
              alignItems={"center"}
              gridTemplateColumns={"30px 1fr 42px"}
              sx={{ borderBottom: "1px solid #eee", py: 1 }}
            >
              <ClockIcon />
              <Stack>
                <Typography variant="body2" color="secondary.light">
                  Time zone
                </Typography>
                <Typography variant="body2" color="initial">
                  {user?.timezone}
                </Typography>
              </Stack>
              <IconButton aria-label="edit" onClick={() => edittimezone(user ?? "")}>
                <EditIcon />
              </IconButton>
            </Box>
          </Paper>
        </Stack> */}
        {/* {
          loading ? (
              <Skeleton sx={{ background: '#fff' }} variant="rectangular" width="100%" height={230} />
          ):(
                <DevicesLogedinList />
          )
        } */}
      </Stack>
      <NameUpdate open={openName} onClose={DialogClose} user={selectedField} />
      <EmailUpdate
        open={openEmail}
        onClose={DialogClose}
        user={selectedField}
      />
      <PhoneUpdate
        open={openPhone}
        onClose={DialogClose}
        user={selectedField}
      />
      <PasswordUpdate open={openPass} onClose={DialogClose} />
      <SetPassword open={openPassword} onClose={DialogClose} />
      <LanguageUpdate open={openlanguage} onClose={DialogClose} user={selectedField} />
      <TimeZoneUpdate open={openTimeZone} onClose={DialogClose} user={selectedField} />
    </Box>
  );
};

export default MyAccount;
